import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { TrackingProvider } from '@utilitywarehouse/tracking-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@utilitywarehouse/hearth-tokens/index.css';
import '@utilitywarehouse/hearth-react/styles.css';
import '@utilitywarehouse/hearth-fonts/index.css';
import './styles/font-overrides.css';
import { ENVIRONMENT } from './config';
import { routeTree } from './routeTree.gen';
import trackingClient from './tracking/trackingClient';

Sentry.init({
  dsn: 'https://9e4b70a596d173cddf0e930ff4a8358e@o31724.ingest.us.sentry.io/4509825338900481',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enabled: ENVIRONMENT !== 'local',
  environment: ENVIRONMENT ?? 'unknown',
});

const queryClient = new QueryClient();

const router = createRouter({
  basepath: '/ref/v2/',
  routeTree,
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TrackingProvider client={trackingClient}>
        <RouterProvider router={router} />
      </TrackingProvider>
    </QueryClientProvider>
  </StrictMode>,
);
